import { useToggle } from '@visikon/utils';
import { useImageFromUri } from '@visikon/utils/src/utils';
import * as React from 'react';
import { useEffect } from 'react';
import { Fader } from '../../common/Fader';
import { EditButton } from '../../components/edit/EditButton';
import { MoveButton } from '../../components/edit/MoveButton';
import { Chevron } from '../../components/styled/Chevron';
import * as Styles from '../../components/styled/DetailsCard';
import Thumbnail from '../../components/Thumbnail';
import { SymptomIcon } from '../../images/SymptomIcon';
import { SymptomData } from '../../reducers/resourcesReducer';
import * as SymStyles from './SymptomCardComponent.styles';

export const renderText = (text: string) => {
  return text
    ?.split('\n')
    .filter((t) => t.trim() !== '')
    .map((t) => <SymStyles.TextBlock key={t}>{t}</SymStyles.TextBlock>);
};

export const renderDetails = (info: SymptomData['infoList'][0]) => {
  return (
    <SymStyles.Details key={info.text} $severity={info.severity}>
      <div>{renderText(info.text)}</div>
      <div>
        <SymptomIcon severity={info.severity} />
        <span style={{ maxWidth: '100%' }}>{info.subtext}</span>
      </div>
    </SymStyles.Details>
  );
};

interface IProps {
  symptom: SymptomData;
  isOpen: boolean;
  onClick: () => void;
  length: number;
  currentPosition: number;
}

export const SymptomCardComponent = ({ symptom, isOpen, onClick, length, currentPosition }: IProps) => {
  const [modalVisible, toggleModal] = useToggle();
  const contentRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (isOpen) toggleModal();
  }, [isOpen]);

  const isFirst = currentPosition === 0;
  const isLast = currentPosition === length - 1;

  const uri = symptom.thumb ? useImageFromUri(symptom.thumb._id) : '';

  useEffect(() => {
    if (isOpen && contentRef.current) {
      contentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [isOpen, contentRef.current]);

  return (
    <Fader>
      <section style={{ padding: 'unset', margin: 'unset' }} ref={contentRef}>
        <div style={{ display: 'flex', gap: '18px', alignItems: 'center', marginTop: '24px' }}>
          <Styles.DetailsCard onClick={onClick}>
            <Thumbnail thumbUrl={uri} />
            <Styles.NameContainer>
              <Styles.DetailsCardName>{symptom.name}</Styles.DetailsCardName>
            </Styles.NameContainer>
            <Chevron isOpen={isOpen} />
          </Styles.DetailsCard>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {!isFirst && <MoveButton direction="up" currentIndex={currentPosition} contentType="symptoms" />}
            {!isLast && <MoveButton direction="down" currentIndex={currentPosition} contentType="symptoms" />}
            <EditButton currentIndex={currentPosition} contentType="symptoms" />
          </div>
        </div>
        {isOpen && (
          <Fader>
            <Styles.DetailsCardContainer>{symptom.infoList?.map(renderDetails)}</Styles.DetailsCardContainer>
          </Fader>
        )}
      </section>
    </Fader>
  );
};
